export default {"logMessage": "50ba77d fix: Changed default cors proxy server","hash":"50ba77d2961eae34eb5d3c7c25ff4c9410f55799"}
